import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Typography,
    Alert,
    Box,
    Divider
} from '@mui/material';

const CierreCajaDialog = ({ open, onClose, onConfirm, caja }) => {
    const [efectivoContado, setEfectivoContado] = useState(caja?.saldoDisponible || 0);
    const [observaciones, setObservaciones] = useState('');

    if (!caja) return null;

    const saldoSistema = Number(caja.saldoDisponible || 0);
    const contado = Number(efectivoContado || 0);
    const diferencia = contado - saldoSistema;

    const handleConfirmar = (e) => {
        e.preventDefault();
        const obs = `${observaciones.trim()} [Arqueo Físico: S/ ${contado.toFixed(2)}, Diferencia: S/ ${diferencia.toFixed(2)}]`;
        onConfirm(caja.id, obs);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', color: '#b91c1c' }}>
                Cierre y Liquidación de Caja Chica
            </DialogTitle>
            <form onSubmit={handleConfirmar}>
                <DialogContent dividers>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        Al cerrar la caja quedará bloqueada para nuevos egresos. Se registrará el arqueo y balance final.
                    </Alert>

                    <Box sx={{ mb: 2, p: 2, bgcolor: '#f8fafc', borderRadius: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {caja.codigo} - {caja.nombre}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                            Sede: {caja.filial} | Responsable: {caja.responsable}
                        </Typography>
                        <Divider sx={{ my: 1 }} />
                        <Typography variant="body2">
                            Fondo Fijo Asignado: <b>S/ {Number(caja.montoFondoFijo).toFixed(2)}</b>
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#1d4ed8', fontWeight: 'bold', mt: 0.5 }}>
                            Saldo Teórico en Sistema: S/ {saldoSistema.toFixed(2)}
                        </Typography>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Efectivo Físico Contado (S/)"
                                type="number"
                                inputProps={{ min: 0, step: '0.10' }}
                                value={efectivoContado}
                                onChange={(e) => setEfectivoContado(e.target.value)}
                                required
                                fullWidth
                                size="small"
                                helperText={
                                    Math.abs(diferencia) < 0.01
                                        ? '✅ Cuadrado perfecto con el sistema'
                                        : diferencia > 0
                                        ? `⚠️ Sobrante de caja: +S/ ${diferencia.toFixed(2)}`
                                        : `❌ Faltante de caja: S/ ${diferencia.toFixed(2)}`
                                }
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Observaciones / Conclusiones del Arqueo"
                                value={observaciones}
                                onChange={(e) => setObservaciones(e.target.value)}
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                placeholder="Indicar comprobantes pendientes de rendición o motivo de diferencias..."
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={onClose} color="inherit">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" color="error">
                        Confirmar Cierre de Caja
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CierreCajaDialog;
